import { SVGProps } from 'react';

const Repeat = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m17 10 4-4-4-4m4 4H7a4 4 0 0 0-4 4v1m4 3-4 4 4 4m-4-4h14a4 4 0 0 0 4-4v-1"
    />
  </svg>
);
export default Repeat;
